import React, { useMemo } from "react";
import objectPath from "object-path";
import { useHtmlClassService } from "../../_core/MetronicLayout";

const FOOTER_LINKS = [
   { label: "Terms of Service", href: "https://www.kaporg.com/terms-of-service" },
   { label: "Privacy Policy", href: "https://www.kaporg.com/privacy-policy" },
   { label: "Cookie Policy", href: "https://www.kaporg.com/cookie-policy" }
];

export function Footer() {
   const today = new Date().getFullYear();
   const uiService = useHtmlClassService();

   const layoutProps = useMemo(() => {
      return {
         footerLayout: objectPath.get(uiService.config, "footer.layout"),
         footerClasses: uiService.getClasses("footer", true),
         footerContainerClasses: uiService.getClasses("footer_container", true)
      };
   }, [uiService]);

   return (
      <div
         className={`footer ${layoutProps.footerClasses}`}
         id="kt_footer"
         style={{
            padding: "20px 40px",
            background: "#ffffff"
         }}
      >
         <div
            className={layoutProps.footerContainerClasses}
            style={{
               display: "flex",
               alignItems: "center",
               justifyContent: "space-between",
               flexWrap: "wrap",
               gap: "12px"
            }}
         >
            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
               <span style={{ color: "#979797", fontFamily: "Poppins", fontSize: "12px", fontWeight: 400 }}>
                  {today} &copy;
               </span>
               <a
                  href="https://kaporg.com/"
                  rel="noopener noreferrer"
                  target="_blank"
                  style={{ color: "#555555", fontFamily: "Poppins", fontSize: "12px", fontWeight: 400 }}
               >
                  KAPorg
               </a>
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: "24px", flexWrap: "wrap" }}>
               {FOOTER_LINKS.map((link) => (
                  <a
                     key={link.href}
                     href={link.href}
                     target="_blank"
                     rel="noopener noreferrer"
                     style={{ color: "#979797", fontFamily: "Poppins", fontSize: "12px", fontWeight: 400 }}
                  >
                     {link.label}
                  </a>
               ))}
            </div>
         </div>
      </div>
   );
}
